import templateAPI from "../api/templates";
import Vue from 'vue';
import {ADD_TOAST_MESSAGE} from "vuex-toast";

const types = {
    LOADING: 'LOADING',
    SET_FIELD: 'SET_FIELD',
    LOADING_BY_KEY: 'LOADING_BY_KEY',
    DOWNLOAD_TEMPLATE_OK: 'DOWNLOAD_TEMPLATE_OK'
};

const initalState = {
    form: {},
    loading: false,
    downloadUrl: ""
};

const getters = {
    form: state => state.form,
    loading: state => state.loading,
    downloadUrl: state => state.downloadUrl,
};

const actions = {
    async downloadTemplate({ commit, dispatch }, email) {
    try {
      const { data } = await templateAPI(dispatch).download(email);
      commit(types.DOWNLOAD_TEMPLATE_OK, data);
    } catch (e) {
      Vue.$log.error('Failed to download the template', e);
      dispatch(
        ADD_TOAST_MESSAGE,
        { text: 'Failed to download the template', type: "danger" },
        { root: true }
      );
    }
  },
};

const mutations = {
    [types.LOADING](state, loading) {
    Vue.set(state, 'loading', loading);
  },

  [types.LOADING_BY_KEY](state, data) {
    Vue.set(state.form, data.key, data.status);
  },

  [types.DOWNLOAD_TEMPLATE_OK](state, data) {
    Vue.set(state, 'downloadUrl', data.downloadUrl);
  },
}

export default {
  namespaced: true,
  state: initalState,
  getters,
  actions,
  mutations,
};